import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SPPO REPORTS RELATED APIs
// ==============================================

// 1. Get Cost Centers for SPPO Close by Vendor
export const getCCForSPPOCloseByVendor = async (params) => {
    try {
        const { Userid, Roleid, CCStatusval } = params;
         // DEBUG
        
        // Validate required parameters
        if (!Userid || !Roleid) {
            throw new Error('Userid and Roleid are required parameters');
        }
        
        const queryParams = new URLSearchParams({
            Userid: Userid,
            Roleid: Roleid,
            CCStatusval: CCStatusval || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetCCForSPPOClsobyVendor?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get DCA for PO Report
export const getDCAForPOReport = async (params) => {
    try {
        const { CCCode } = params;
         // DEBUG
        
        // Validate required parameters
        if (!CCCode) {
            throw new Error('CCCode is a required parameter');
        }
        
        const queryParams = new URLSearchParams({
            CCCode: CCCode
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetDCAForPOReport?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Vendors for SPPO Report
export const getVendorsForSPPOReport = async (params) => {
    try {
        const { CCCode, DCA } = params;
         // DEBUG
        
        // Validate required parameters
        if (!CCCode || !DCA) {
            throw new Error('CCCode and DCA are required parameters');
        }
        
        const queryParams = new URLSearchParams({
            CCCode: CCCode,
            DCA: DCA
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetVendorsForSPPOReport?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get SPPO Report Data (POST)
export const getSPPOReportData = async (params) => {
    try {
        const { CCCode, DCACode, VendorCode, month, year, Status, CCStatus } = params;
         // DEBUG
        
        // Validate required parameters (month can be empty)
        if (!CCCode || !DCACode || !VendorCode || year === undefined || year === null || year === '' || !Status) {
            throw new Error('CCCode, DCACode, VendorCode, year, and Status are required parameters');
        }
        
        // Validate PO status (legacy values: SelectAll / Open = Running / Closed)
        if (!['SelectAll', 'Open', 'Closed'].includes(Status)) {
            throw new Error('Status must be "SelectAll", "Open" or "Closed"');
        }
        
        // Transform parameters to match backend expectations
        // spGetSppoReport reads POStatus / Month / Year / CostCenterStatus off the SPPO model
        // (sending "Status" bound to SPPO.Status instead, so the PO status filter was ignored).
        const transformedParams = {
            CCCode: CCCode,
            DCACode: DCACode,
            VendorCode: VendorCode === '' ? 'SelectAll' : VendorCode,
            Month: month === '' ? '0' : String(month),
            Year: year, // financial year (e.g. 2025-26) or 'Any' for all years
            POStatus: Status,
            CostCenterStatus: CCStatus || ''
        };
        
        // Log what we're actually sending
        
        const requestBody = transformedParams;
        
        const response = await axios.post(
            `${API_BASE_URL}/Reports/GetSPPOReportData`,
            requestBody,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get SPPO for Print
export const getSPPOForPrint = async (params) => {
    try {
        const { SPPONO } = params;
         // DEBUG
        
        // Validate required parameters
        if (!SPPONO) {
            throw new Error('SPPONO is a required parameter');
        }
        
        const queryParams = new URLSearchParams({
            SPPONO: SPPONO
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetSPPOForPrint?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};